<template>
    <div class="panels-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Responsive Images</h3>
                </div>

                <img src="../../assets/images/blog/blog-1.jpg" style="width: 100%" class="img-fluid" alt="blog-1">
            </div>
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Thumbnails</h3>
                </div>

                <img src="../../assets/images/blog/blog-2.jpg" style="width: 200px" class="img-thumbnail" alt="blog-1">
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Thumbnails</h3>
                </div>

                <div class="thumbnails-2 d-flex justify-content-between pb-24">
                    <img src="../../assets/images/blog/blog-3.jpg" style="width: 200px" class="rounded" alt="blog-1">
                    <img src="../../assets/images/blog/blog-4.jpg" style="width: 200px" class="rounded" alt="blog-1">
                </div>

                <img src="../../assets/images/blog/blog-3.jpg" style="width: 200px" class="rounded mx-auto d-block" alt="blog-1">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThumbnailsContent'
}
</script>

<style lang="scss">
/* Max width 767px */
@media only screen and (max-width: 767px) {
    .thumbnails-2 {
        display: block !important;
        text-align: center;
        img {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>